<app-circular-selection [options]="surveys[survey_current_indx]?.options" [showBackBtn]="false" [scrollableDiv]="scrollableDiv" [highlightText]="highlightText"  (onClickAction)="clicked($event)" [config]="config">
  <div #scrollableDiv heading *ngIf="surveys[survey_current_indx]">
    <div>
      {{surveys[survey_current_indx].question}}
    </div>
    <div class="subHeading">
      <span #highlightText >{{surveys[survey_current_indx].subHeading}}</span>
    </div>
  </div>
</app-circular-selection>

<form #dummyForm="ngForm" style="display: none;"></form>

<div class="container-form-nav-button"><app-form-navigation-buttons [fireEvent]="fireEvent" [isValid]="enableContinue" [form]="dummyForm" [userProfile]="userProfile"></app-form-navigation-buttons>
</div>
